<template>
<q-card class="page-card">
  <q-card-section v-if="$isDesktop" class="page-card__main-content">
    <h1 class="heading-2 q-mb-lg">Externe bronnen</h1>
    <div class="row items-center justify-between">
      <div class="col-shrink">
        Kies een bron om vandaan te impoteren uit de lijst.
      </div>
    </div>
  </q-card-section>
  <q-card-section v-else class="page-card__main-content">
    <h1 class="heading-2 q-pl-sm">Externe bronnen</h1>
    <ImportSourceIndex :sources="sources" class="q-mt-md" />
  </q-card-section>
</q-card>
</template>
<script>
import ImportSourceIndex from '~HIOR/components/sidebars/ImportSourceIndex.vue'

export default {
  components: {
    ImportSourceIndex,
  },
  props: {
    sources: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
